import { Outlet } from 'react-router-dom';

const ForgotPasswordOrLogin = () => {
  return <Outlet />;
};

export default ForgotPasswordOrLogin;
